"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.object.to-string.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _ghn = require("@/api/ghn");
var _order = require("@/api/order");
var _pickup = require("@/api/pickup");
var _vuePropertyDecorator = require("vue-property-decorator");
var _FilterOrder = require("./FilterOrder.vue");
var _order2 = require("@/types/order");
var AddAddressGHTK = /*#__PURE__*/function (_Vue) {
  function AddAddressGHTK() {
    var _this;
    (0, _classCallCheck2.default)(this, AddAddressGHTK);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, AddAddressGHTK, [].concat(args));
    (0, _defineProperty2.default)(_this, "orderStatus", void 0);
    (0, _defineProperty2.default)(_this, "data", void 0);
    (0, _defineProperty2.default)(_this, "type", void 0);
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    (0, _defineProperty2.default)(_this, "form", {});
    (0, _defineProperty2.default)(_this, "loading", false);
    (0, _defineProperty2.default)(_this, "loadingButton", false);
    (0, _defineProperty2.default)(_this, "pickup", []);
    (0, _defineProperty2.default)(_this, "lotnumbers", []);
    (0, _defineProperty2.default)(_this, "OrderStatus", _FilterOrder.OrderStatus);
    (0, _defineProperty2.default)(_this, "GHTKTransportType", _order2.GHTKTransportType);
    (0, _defineProperty2.default)(_this, "GHTKTransportTypeTrans", _order2.GHTKTransportTypeTrans);
    (0, _defineProperty2.default)(_this, "usingCustomerAddress", false);
    (0, _defineProperty2.default)(_this, "cities", []);
    (0, _defineProperty2.default)(_this, "districts", []);
    (0, _defineProperty2.default)(_this, "wards", []);
    (0, _defineProperty2.default)(_this, "totalMoney", 0);
    (0, _defineProperty2.default)(_this, "rules", {
      cityId: {
        required: true,
        message: "Field is required",
        trigger: "submit"
      },
      districtId: {
        required: true,
        message: "Field is required",
        trigger: "submit"
      },
      wardCode: {
        required: true,
        message: "Field is required",
        trigger: "submit"
      },
      receiverPhone: {
        required: true,
        message: "Field is required",
        trigger: "submit"
      },
      address: {
        required: true,
        message: "Field is required",
        trigger: "submit"
      },
      cod: {
        required: true,
        message: "Field is required",
        trigger: "submit"
      },
      isFreeship: {
        required: true,
        message: "Field is required",
        trigger: "submit"
      },
      totalWeight: {
        required: true,
        message: "Field is required",
        trigger: "submit"
      }
    });
    return _this;
  }
  (0, _inherits2.default)(AddAddressGHTK, _Vue);
  return (0, _createClass2.default)(AddAddressGHTK, [{
    key: "watchData",
    value: function watchData(val) {
      this.form = {
        detailCustomer: val.detailCustomer,
        isFreeship: false,
        id: val.id,
        cityId: null,
        districtId: null,
        wardCode: null,
        cod: 0,
        totalWeight: 1,
        ghtkTransport: _order2.GHTKTransportType.Road
      };
      this.usingCustomerAddress = false;
      this.totalMoney = 0;
      this.fetchData();
    }
  }, {
    key: "handleChangeUsingAddress",
    value: function handleChangeUsingAddress() {
      if (!this.usingCustomerAddress) {
        this.form = (0, _objectSpread2.default)({}, this.form);
      } else if (this.form.detailCustomer.customer) {
        var customer = this.form.detailCustomer.customer;
        this.$set(this.form, "cityId", customer.receiverCityId);
        this.$set(this.form, "districtId", customer.receiverDistrictId);
        this.$set(this.form, "wardCode", customer.receiverWardCode);
        this.form.name = customer.name;
        this.form.phone = customer.phone;
        this.form.address = customer.receiverAddress;
      }
    }
  }, {
    key: "fetchData",
    value: function fetchData(search) {
      var _this2 = this;
      this.loading = true;
      _pickup.pickUpApi.findAll({
        limit: 50,
        page: 1,
        search: search,
        type: this.type
      }).then(function (res) {
        _this2.pickup = res.data.pickUps;
        if (res.data.pickUps.length) {
          _this2.$set(_this2.form, "pickUpId", res.data.pickUps[0].id);
        }
      }).finally(function () {
        return _this2.loading = false;
      });
    }
  }, {
    key: "created",
    value: function created() {
      this.fetchData();
      this.fetchCities();
    }
  }, {
    key: "watchCity",
    value: function watchCity() {
      var _this3 = this;
      if (this.form.cityId) {
        this.fetchDistricts();
      }
      var city = this.cities.find(function (e) {
        return e.ProvinceID == _this3.form.cityId;
      });
      this.form.cityName = city && city.ProvinceName;
      this.form.cityCode = city && city.Code;
    }
  }, {
    key: "watchDistrictId",
    value: function watchDistrictId() {
      var _this4 = this;
      if (this.form.districtId) {
        this.fetchWards();
      }
      var district = this.districts.find(function (e) {
        return e.DistrictID == _this4.form.districtId;
      });
      this.form.districtName = district && district.DistrictName;
      this.form.districtCode = district && district.Code;
    }
  }, {
    key: "watchWardCode",
    value: function watchWardCode() {
      var _this5 = this;
      var ward = this.wards.find(function (e) {
        return e.WardCode == _this5.form.wardCode;
      });
      this.form.wardName = ward && ward.WardName;
    }
  }, {
    key: "handleChangeDistrict",
    value: function handleChangeDistrict() {
      this.form.wardCode = null;
    }
  }, {
    key: "handleChangeCity",
    value: function handleChangeCity() {
      this.$set(this.form, "districtId", null);
      this.$set(this.form, "wardCode", null);
    }
  }, {
    key: "fetchCities",
    value: function () {
      var _fetchCities = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _ghn.ghnApi.findCity();
            case 2:
              res = _context.sent;
              this.cities = res.data.data;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetchCities() {
        return _fetchCities.apply(this, arguments);
      }
      return fetchCities;
    }()
  }, {
    key: "fetchDistricts",
    value: function () {
      var _fetchDistricts = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _ghn.ghnApi.findDistrict({
                province_id: this.form.cityId
              });
            case 2:
              res = _context2.sent;
              this.districts = res.data.data;
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function fetchDistricts() {
        return _fetchDistricts.apply(this, arguments);
      }
      return fetchDistricts;
    }()
  }, {
    key: "fetchWards",
    value: function () {
      var _fetchWards = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _ghn.ghnApi.findWard({
                district_id: this.form.districtId
              });
            case 2:
              res = _context3.sent;
              this.wards = res.data.data;
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function fetchWards() {
        return _fetchWards.apply(this, arguments);
      }
      return fetchWards;
    }()
  }, {
    key: "handleEstimate",
    value: function () {
      var _handleEstimate = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4() {
        var data, res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return this.$refs.form.validate();
            case 3:
              this.loadingButton = true;
              data = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.form), {}, {
                pickUpId: this.form.pickUpId
              });
              _context4.next = 7;
              return _order.orderApi.estimateGHTK(this.form.id, data);
            case 7:
              res = _context4.sent;
              this.totalMoney = res.data.result;
            case 9:
              _context4.prev = 9;
              this.loadingButton = false;
              return _context4.finish(9);
            case 12:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[0,, 9, 12]]);
      }));
      function handleEstimate() {
        return _handleEstimate.apply(this, arguments);
      }
      return handleEstimate;
    }()
  }]);
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({})], AddAddressGHTK.prototype, "orderStatus", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({})], AddAddressGHTK.prototype, "data", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({})], AddAddressGHTK.prototype, "type", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)("data", {
  deep: true,
  immediate: true
})], AddAddressGHTK.prototype, "watchData", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)("form.cityId")], AddAddressGHTK.prototype, "watchCity", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)("form.districtId"), (0, _vuePropertyDecorator.Watch)("districts")], AddAddressGHTK.prototype, "watchDistrictId", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)("form.wardCode"), (0, _vuePropertyDecorator.Watch)("wards")], AddAddressGHTK.prototype, "watchWardCode", null);
AddAddressGHTK = (0, _tslib.__decorate)([_vuePropertyDecorator.Component], AddAddressGHTK);
var _default = exports.default = AddAddressGHTK;